<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClimbingGroupsSupplyIndex'
}
</script>
